module.exports = __webpack_public_path__ + "img/1465642215.edd0e92c.jpg";